import React, { useEffect, useState } from 'react';
import { Button, message, Modal, Typography, Popconfirm, Steps, Table, Tooltip, Image, Space } from 'antd';
import { Link, useParams, useHistory } from 'react-router-dom';
import { RightOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { reconciliationDetail, updateReconciliation } from './api';
import { BILL_STATUS } from './billConst';
import CpProductInfo from '../../components/CpProductInfo';
import { amountToString, downLoad } from '../../util/tool';
import RenderCostDetail from './components/renderCostDetail';
import Signature from './components/signature';
import { v4 as uuidv4 } from 'uuid';
import { currency } from '../quotationProduct/formatNumber';
import './index.less';

// const { Step } = Steps;
const stepStatus = Reflect.ownKeys(BILL_STATUS).map(item => ({ name: BILL_STATUS[+item], status: +item }));
export default function Detail() {
  const history = useHistory();
  const { id } = useParams();
  const [update, setUpdate] = useState(false);
  const [current, steCurrent] = useState(0);
  const [finallyStepStatus, setFinallyStepStatus] = useState([]);
  const [itemTableData, setItemTableData] = useState([]);
  const [billInfo, setBillInfo] = useState({});
  const [modalVisible, setVisibleModal] = useState(false);
  const [reconciliationNo, setReconciliationNo] = useState('');

  useEffect(() => {
    async function getReconciliationDetail() {
      const { data: { code, msg, data } } = await reconciliationDetail(({ reconciliation_no: id }));
      if (+code === 0) {
        const { status } = data;
        setBillInfo(data);
        const finallyStepStatus = +status === 50 ? (stepStatus || []).filter(item => ![20, 30, 40].includes(+item.status)) : stepStatus.slice(0, 4);
        const index = finallyStepStatus.findIndex(item => +item.status === +status);
        setFinallyStepStatus(finallyStepStatus);
        steCurrent(index);
      } else {
        message.error(msg);
      }
    }
    getReconciliationDetail();
  }, [update, id]);

  const pay = async (reconciliation_no, status) => {
    const { data: { code, msg } } = await updateReconciliation({ reconciliation_no, status });
    if (+code === 0) {
      message.success(msg, .5, setUpdate(!update));
    } else {
      message.error(msg);
    }
  };

  const showProductDetail = record => {
    const { product_info = [] } = record;
    setVisibleModal(true);
    setItemTableData(product_info);
  };

  const handleCancel = () => {
    setVisibleModal(false);
    setItemTableData([]);
  };

  const openSignModal = ({ reconciliation_no }) => {
    setReconciliationNo(reconciliation_no);
  };

  const updateInfo = () => {
    setReconciliationNo('');
    setUpdate(!update);
  };

  const onCancel = () => {
    setReconciliationNo('');
  };

  const downLoadFile = () => {
    const [file] = billInfo.signature_file;
    downLoad({ ...file });
  };

  const print = () => {
    const { reconciliation_no } = billInfo;
    history.push(`/basic/user/bill/print/${reconciliation_no}`);
  };

  const columns = [
    {
      title: '订单号',
      dataIndex: 'order_no',
    },
    {
      title: 'ERP订单编号',
      dataIndex: 'purchase_order_no',
    },
    // {
    //   title: '实收总金额未税(元)',
    //   dataIndex: 'receive_amount',
    //   render: text => amountToString(text)
    // },
    // {
    //   title: '总税额(元)',
    //   dataIndex: 'tax_total_amount',
    //   render: text => amountToString(text)
    // },
    {
      title: '商品应收总金额含税(元)-合计(元)',
      dataIndex: 'tax_inclusive_amount',
      render: text => amountToString(text)
    },
    {
      title: '费用(元)',
      dataIndex: 'freight_amount',
      render: (_, record) => <RenderCostDetail record={record} />,
    },
    {
      title: '结算金额含税(元)',
      dataIndex: 'complete_amount_total',
      render: text => amountToString(text)
    },
    {
      title: '操作',
      fixed: 'right',
      render: (_, record) => <Typography.Link className='bill-operate-btn promote-btn' onClick={() => showProductDetail(record)}>商品明细</Typography.Link>,
    },
  ];
  const itemColumns = [
    {
      title: '商品',
      dataIndex: 'sku_name',
      render: (_, record) => <CpProductInfo product={record}></CpProductInfo>
    },
    {
      title: '单价(元)',
      dataIndex: 'sale_price',
      key: 'sale_price',
      render: (text) => <a>¥{currency(text)}</a>,
    },
    {
      title: '商品数量',
      dataIndex: 'sale_number',
    },
    {
      title: '收货数量',
      dataIndex: 'receive_number',
    },
    // {
    //   title: '折扣金额(元) ',
    //   dataIndex: 'discount_amount',
    //   render: text => amountToString(text)
    // },
    // {
    //   title: '实收金额未税(元)',
    //   dataIndex: 'receive_amount',
    //   render: text => amountToString(text)
    // },
    {
      title: '税率',
      dataIndex: 'tax_rate',
    },
    // {
    //   title: '税额(元)',
    //   dataIndex: 'tax_amount',
    //   render: text => amountToString(text)
    // },
    // {
    //   title: '实收金额含税(元)',
    //   dataIndex: 'real_amount',
    //   render: (text, record) => {
    //     const { receive_amount = 0, tax_amount = 0 } = record;
    //     return amountToString(accAdd(receive_amount, tax_amount));
    //   }
    // },
    {
      title: '商品小计含税（元）',
      dataIndex: 'receive_tax_inclusive_cost',
      key: 'receive_tax_inclusive_cost',
      render: (text) => <a>{currency(text)}</a>
    },
    {
      title: <>商品综合单价<Tooltip title='商品平均成本，由商品单价+增值税费+平均费用计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
      dataIndex: 'receive_complete_sale_price',
      key: 'receive_complete_sale_price',
      render: (text, record) => <a>¥{currency(text)}</a>
    },
    {
      title: <>商品综合小计<Tooltip title='商品综合小计，由商品小计+进口关税税费+增值税费+商品产生费用计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
      dataIndex: 'receive_complete_total',
      key: 'receive_complete_total',
      render: (text) => <a>{currency(text)}</a>
    }
  ];

  const items = finallyStepStatus?.map(item => ({ title: item.name })) || [];

  return (
    <div className='bill-container'>
      <Space className='mb-20' split={<RightOutlined />}>
        <Link to={{ pathname: '/basic/user/bill' }}>我的对账单</Link>
        <span>对账单号：{id}</span>
      </Space>
      <div className='bill-progress-container'>
        <div className='bill-progress-left'>
          <div className='bill-progress-left-num'>对账单号：{id}</div>
          <div className='bill-status-container'>
            <span className='bill-status'>{BILL_STATUS[+billInfo?.status]}</span>
            <div>
              {/* <button onClick={() => pay(id, '10')}>change status</button> */}
              <Button size='small' className='bill-status-btn' onClick={print}>打印/下载账单</Button>
              {
                +billInfo?.status === 10 ? <>
                  {+billInfo.is_signature === 0 ? <Popconfirm title={`是否账单确认?`} cancelText='驳回' onConfirm={() => pay(id, '20')}>
                    <Button size='small' className='bill-status-btn'>账单确认</Button>
                  </Popconfirm> : <Button size='small' className='bill-status-btn' onClick={() => openSignModal(billInfo)}>账单确认</Button>}
                </> : null
              }
              {
                +billInfo?.status === 20 ? (<Popconfirm title={`是否确认支付?`} onConfirm={() => pay(id, '30')}>
                  <Button size='small' className='bill-status-btn'>确认支付</Button>
                </Popconfirm>) : null
              }
              {
                +billInfo?.status === 10 ? (<Popconfirm title={`是否驳回账单?`} onConfirm={() => pay(id, '50')}>
                  <Button className='bill-status-btn' size='small'>驳回账单</Button>
                </Popconfirm>) : null
              }
            </div>
          </div>
        </div>
        <div className='bill-progress-right'>
          <div className='bill-progress-right-title'>账单状态</div>
          <Steps current={current} size="small" items={items}>
            {/* {
              (finallyStepStatus || []).map((item, index) => {
                return (
                  <Step
                    key={index}
                    title={item.name}>
                  </Step>
                );
              })
            } */}
          </Steps>
        </div>
      </div>
      <div className='bill-information'>
        <div className='bill-information-item'>
          <div className='bill-information-item-title'>买家信息</div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>采购方编码：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.purchase_info?.company_id}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>采购方名称：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.purchase_info?.company_name || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>税号：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.purchase_info?.credit_code || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>开户行：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.purchase_info?.bank_name || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>银行账户：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.purchase_info?.bank_account || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>电话：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.purchase_info?.telephone || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>地址：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.purchase_info?.address || '--'}</span>
          </div>
        </div>
        <div className='bill-information-item'>
          <div className='bill-information-item-title'>卖家信息</div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>供应商编码：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.supplier_info?.company_id || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>供应商名称：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.supplier_info.company_name || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>税号：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.supplier_info?.credit_code || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>开户行：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.supplier_info?.bank_name || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>银行账户：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.supplier_info?.bank_account || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>电话：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.supplier_info?.telephone || '--'}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>地址：</span>
            <span className='bill-information-subitem-detail'>{billInfo?.order_info?.[0]?.supplier_info?.address || '--'}</span>
          </div>
        </div>
        <div className='bill-information-item'>
          <div className='bill-information-item-title'>账单信息</div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>结算金额含税-合计(元)：</span>
            <span className='bill-information-subitem-detail'>{amountToString(billInfo?.statement_amount || 0)}</span>
          </div>
          <div className='bill-information-item-title'>备注</div>
          <div className='bill-information-subitem'>
            {/* <span className='bill-information-subitem-desc'>备注：</span> */}
            <span className='bill-information-subitem-detail' style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: billInfo?.desc }}></span>
          </div>
          {/* <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>费用-合计(元)：</span>
            <span className='bill-information-subitem-detail'>{amountToString(billInfo?.freight_amount || 0)}</span>
          </div>
          <div className='bill-information-subitem'>
            <span className='bill-information-subitem-desc'>实收总金额含税-合计(元)：</span>
            <span className='bill-information-subitem-detail'>{amountToString(billInfo?.receive_amount || 0)}</span>
          </div> */}
        </div>
      </div>
      <Table
        className='bill-order-info-table'
        dataSource={billInfo?.order_info || []}
        columns={columns}
        scroll={{ x: 1800 }}
        rowKey={() => uuidv4()}
        pagination={false}
      />

      <>
        {
          billInfo.signature_file?.length ? <>
            {
              +billInfo.signature_type === 1 ? <div className='signature-item'>
                <div>采购方签字/盖章：</div>
                <Image width={200} preview={false} src={billInfo.signature_file?.[0]?.url} />
              </div> : null
            }
            {
              +billInfo.signature_type === 2 ? <div className='signature-item'>
                <div>已签章账单: <Typography.Link>{billInfo.signature_file?.[0]?.name}</Typography.Link></div>
                <Button size='small' style={{ marginLeft: 20 }} onClick={downLoadFile}>下载</Button>
              </div> : null
            }</> : null
        }
      </>

      <Modal
        open={modalVisible}
        centered
        width={1242}
        footer={false}
        onCancel={handleCancel}
      >
        <Table
          bordered
          dataSource={itemTableData || []}
          columns={itemColumns}
          rowKey='id'
          pagination={false}
        />
      </Modal>

      {reconciliationNo ? <Signature reconciliation_no={reconciliationNo} update={updateInfo} onCancel={onCancel} /> : null}
    </div>
  );
}
